import * as angular from 'angular';
import './relevant-articles.scss';
import { Component } from 'ng-metadata/core';


/**
 * @ngdoc directive
 * @name mwMediaContactDocumentRelevantArticles
 * @module mw.components.contentDocuments
 *
 * @usage
 * <hljs hljs-language="html">
 *     <mw-media-contact-document-relevant-articles>
 *          <mw-media-document
 *              ng-repeat="mediaDocument in contact.documents track by mediaDocument.documentId"
 *              document="mediaDocument">
 *          </mw-media-document>
 *      </mw-media-contact-document-relevant-articles>
 * </hljs>
 */

@Component({
    selector: 'mw-media-contact-document-relevant-articles',
    template: `
        <ng-transclude></ng-transclude>
    `,
    legacy: {
        transclude: true
    }
})
export class MediaContactDocumentRelevantArticlesComponent {

}


// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-contact-document/relevant-articles/relevant-articles.component.ts